export default __webpack_public_path__ + "static/media/chatr.f9af01b6.png";